var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadViewDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.114258,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#A44EF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1143 29C15.1517 29 11.1143 24.9625 11.1143 20C11.1143 15.0375 15.1517 11 20.1143 11C25.0768 11 29.1143 15.0375 29.1143 20C29.1143 24.9625 25.0786 29 20.1143 29ZM20.1143 12.3433C15.8923 12.3433 12.4575 15.7781 12.4575 20C12.4575 24.2219 15.8923 27.6567 20.1143 27.6567C24.3362 27.6567 27.771 24.2219 27.771 20C27.771 15.7781 24.3362 12.3433 20.1143 12.3433Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1531 14.93C20.5184 14.93 20.8144 15.2261 20.8144 15.5913V19.7261L23.266 22.1777C23.5242 22.4359 23.5242 22.8547 23.266 23.1129C23.0077 23.3712 22.589 23.3712 22.3308 23.1129L19.6855 20.4677C19.5615 20.3437 19.4918 20.1755 19.4918 20.0001V15.5913C19.4918 15.2261 19.7879 14.93 20.1531 14.93Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadViewDm);
export default __webpack_public_path__ + "static/media/lead_view_dm.b13a8080295898f46efb6d0a73a69a53.svg";
export { ForwardRef as ReactComponent };